import axios from "axios";
import { getAuthData, clearStorage } from "../Utils/storage";
import { notifyError } from "../Utils/toastify";

const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "x-nc-tool-id": "0830b812-868a-4ecf-81fc-f83cbcfb74aa",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const user = getAuthData();
    if (user) {
      const { token, ownerUserId, systemUserId, token_type, realmIdentifier } = user;
      config.headers["Authorization"] = `${token_type} ${token}`;
      config.headers["x-nc-provider-id"] = "Ninjacart";
      config.headers["x-nc-user-id"] = ownerUserId;
      config.headers["x-nc-system-user-id"] = systemUserId;
      config.url = config.url.replace("$USER_ID", systemUserId);
      config.url = config.url.replace("$REALM_ID", realmIdentifier);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response && error?.response?.status === 401) {
      clearStorage();
      window.location.pathname = "/login-email";
      notifyError("Session expired. Redirecting to login...");
      return Promise.reject("Session expired. Redirecting to login...");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
